import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useAtom } from "jotai";
import classNames from "classnames";
import { Intent } from "@/model";
import { useCreateIntentSentence } from "@/query/sentence";
import { intentTableEditAtom } from "@/atom/intentTable";
import { errorToast, successToast } from "@/component/Toast";


export interface SentenceFormProps {
    intent: Intent;
}

const SentenceForm: React.FC<SentenceFormProps> = (props) => {
    const { intent } = props;

    const intl = useIntl();

    const inputRef = useRef<HTMLInputElement>(null);
    const [validated, setValidated] = useState<boolean>(false);

    const [intentTableEdit, setIntentTableEdit] = useAtom(intentTableEditAtom);

    const { mutateAsync: createSentence, isPending: isCreating } = useCreateIntentSentence(
        intent.agent_id,
        intent.skill_id,
        intent.id
    );

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const sentence = inputRef.current?.value.trim() || "";
        if (!sentence) {
            setValidated(true);
            return;
        }

        await createSentence({ sentence })
            .then(() => {
                successToast(intl.formatMessage({ id: "t001" }));
                if (inputRef.current) {
                    inputRef.current.value = "";
                }
                setValidated(false);
                setIntentTableEdit(prev => {
                    delete prev[`${intent.id}_sentence_edit`];
                    return prev;
                });
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            });
    };

    const onInput = () => {
        setIntentTableEdit(prev => {
            prev[`${intent.id}_sentence_edit`] = inputRef.current?.value ?? "";
            return prev;
        });
    };

    useEffect(() => {
        if (intentTableEdit[`${intent.id}_sentence_edit`] !== undefined && inputRef.current)
            inputRef.current.value = intentTableEdit[`${intent.id}_sentence_edit`];
        // eslint-disable-next-line
    }, []);

    return (
        <div role="row">
            <form className="relative h-[51px] pl-[58px] selection-table-form !items-center"
                  onSubmit={onSubmit}
            >
                <input type="text"
                       ref={inputRef}
                       className={classNames(validated && "input-invalid")}
                       placeholder={intl.formatMessage({ id: "i03054" })}
                       disabled={isCreating}
                       onInput={onInput}
                />
            </form>
        </div>
    );
};

export default SentenceForm;